/* Phantasmagorical: relocate the Fera product-reviews widget into a collapsible
   "Reviews" row placed right after the buy box, and make the header rating a
   jump-to-reviews control. Loaded on product pages via snippets/theme-globals.liquid. */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;

  function buildAccordion() {
    var existing = document.getElementById('pg-reviews-details');
    if (existing) return existing;
    var wrap = document.createElement('div');
    wrap.className = 'pg-reviews-block product__block product__block--medium';
    wrap.innerHTML =
      '<details class="pg-reviews-details" id="pg-reviews-details">' +
        '<summary class="pg-reviews-details__summary">' +
          '<span class="pg-reviews-details__title ff-heading fs-heading-5-base">Reviews</span>' +
          '<span class="pg-reviews-details__marker" aria-hidden="true"></span>' +
        '</summary>' +
        '<div id="pg-reviews-slot" class="pg-reviews-details__content"></div>' +
      '</details>';
    var atc = document.querySelector('.product-form__submit, form[action*="/cart/add"] [type="submit"], [name="add"]');
    var anchor = atc ? (atc.closest('.product__block') || atc.closest('.product-form') || atc.closest('form')) : null;
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    } else {
      var col = document.querySelector('.product__info, .product-info, .product__column-right, .product');
      (col || document.body).appendChild(wrap);
    }
    return document.getElementById('pg-reviews-details');
  }

  function moveReviews() {
    var slot = document.getElementById('pg-reviews-slot');
    var w = document.querySelector('.fera-productReviews-widget') || document.querySelector('.fera-reviews-widget');
    if (slot && w && !slot.contains(w)) { slot.appendChild(w); return true; }
    return false;
  }

  function openReviews(det, e) {
    if (e && e.preventDefault) e.preventDefault();
    det.open = true;
    det.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function wireRating(det) {
    var list = document.querySelectorAll('.product-rating');
    for (var i = 0; i < list.length; i++) {
      var r = list[i];
      if (r.getAttribute('data-pg-wired') || r.offsetParent === null) continue;
      r.setAttribute('data-pg-wired', '1');
      r.setAttribute('role', 'button');
      r.setAttribute('tabindex', '0');
      r.setAttribute('aria-label', 'Read reviews');
      r.addEventListener('click', function (e) { openReviews(det, e); });
      r.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') openReviews(det, e); });
    }
  }

  function init() {
    var det = buildAccordion();
    if (!det) return;
    wireRating(det);
    if (!moveReviews()) {
      var obs = new MutationObserver(function () { if (moveReviews()) obs.disconnect(); });
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 20000);
    }
    // rating may render slightly later
    setTimeout(function () { wireRating(det); }, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
